export default [
    {
        
        path: 'import-orders-list',
        name: '订单查询',
        component: () => import('../views/orders/import-orders-list.vue'),
        meta: {
            type: '01',
        }
  
    },
    {
        
        path: 'import-orders-detail',
        name: '进口订单详情',
        component: () => import('../views/orders/import-orders-detail.vue'),
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            type: '01'
        }
    },
    {
        
        path: 'wait-payment-list',
        name: '付汇申请',
        component: () => import('../views/my-account/wait-payment-list.vue'),
        meta: {
            type: '01'
        }
  
    },
    {
        
        path: 'pledging-payment-list',
        name: '付汇记录',
        component: () => import('../views/my-account/pledging-payment-list.vue'),
        meta: {
            type: '01'
        }
  
    },
    {
        
        path: 'delivery-notice',
        name: '我要发货',
        component: () => import('../views/my-logistics/logistics-list.vue'),
        meta: {
            
        }
  
    },
    {
        
        path: 'delivery-history',
        name: '发货记录',
        component: () => import('../views/my-logistics/logistics-recording.vue'),
        meta: {
           
        }
  
    },
    {
        path: 'logistics-detail',
        name: '发货详情',
        component: () => import('../views/my-logistics/logistics-detail.vue'),
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            
        }
    },
    {
        
        path: 'pickUp-list',
        name: '我要提货',
        component: () => import('../views/my-logistics/pickUp-list.vue'),
        meta: {
           
        }
  
    },
    {        
        path: 'pickUp-detail',
        name: '提货详情',
        component: () => import('../views/my-logistics/pickUp-detail.vue'), 
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            
        } 
    },
    {
        
        path: 'import-statement-list',
        name: '账单信息',
        component: () => import('../views/my-account/import-statement-list.vue'),
        meta: {
            type: '01'
        }
  
    },
    {
        
        path: 'payable-list',
        name: '付款记录',
        component: () => import('../views/my-account/payable-list.vue'),
        meta: {
            type: '01'
        }
    },
    {
        
        path: 'invoice-list',
        name: '开票申请',
        component: () => import('../views/my-account/invoice-list.vue'),
        meta: {
           
        }
  
    },
    {        
        path: 'invoice-history',
        name: '开票记录',
        component: () => import('../views/my-account/invoice-recording.vue'),
        meta: {
           
        }  
    },
    {        
        path: 'invoice-add',
        name: '开票新增',
        component: () => import('../views/my-account/invoice-add.vue'),  
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
           
        }  
    },
    {        
        path: 'invoice-detail',
        name: '开票详情',
        component: () => import('../views/my-account/invoice-detail.vue'),
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            
        }  
    },
    {        
        path: 'my-quota',
        name: '垫税提额',
        component: () => import('../views/user-center/my-quota.vue'),  
        meta: {
            sidebarFold: true,
            type: '01'
        }
    },
    {        
        path: 'account-management',
        name: '账号管理',
        component: () => import('../views/user-center/account_management.vue'), 
        meta: {
            sidebarFold: true,
           
        }
    },
    {        
        path: 'signProtocol-list',
        name: '签署协议',
        component: () => import('../views/user-center/signProtocol-list.vue'), 
        meta: {
            sidebarFold: true,
           
        }
    },
    {        
        path: 'exchange-rate-list',
        name: '汇率详情',
        component: () => import('../views/user-center/exchange-rate-list.vue'), 
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            
        }   
    },
    {        
        path: 'warehouse-info',
        name: '仓库信息',
        component: () => import('../views/workbench/warehouse-info.vue'),  
        meta: {
            sidebarFold: true,
           
        }
    },
    {        
        path: 'receive-account',
        name: '收款账号',
        component: () => import('../views/workbench/receive-account.vue'),  
        meta: {
            sidebarFold: true,
           
        }
    },
    {        
        path: 'sign-contract',
        name: '签约',
        component: () => import('../views/sign-contract/index.vue'), 
        meta: {
            sidebarFold: true,
           
        }
    },
    {
        path: 'pledging-payment-detail',
        name: '付汇申请详情',
        component: () => import('../views/my-account/pledging-payment-detail.vue'),  
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            type: '01'
        }
    },
    {        
        path: 'import-statement-detail',
        name: '进口对账单详情',
        component: () => import('../views/my-account/import-statement-detail.vue'),  
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            type: '01'
        }
    },
    {
        path: '/my-list',
        name: '我的',
        component: () => import('../views/personal-center/my.vue'),
        meta: {
            type: '06'
        }
      },
      {
        path: '/my-center',
        name: '个人中心',
        component: () => import('../views/personal-center/my-center.vue'),
        meta: {
            sidebarFold: true,
            type: '01'
        }
      },
      {
        path: '/my-enterprise',
        name: '企业信息',
        component: () => import('../views/personal-center/my-enterprise.vue'),
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            sidebarFold: true,
            type: '01'
        }
      },
      {
        path: '/material-management',
        name: '物料管理',
        component: () => import('../views/personal-center/Materials-list.vue'),
        meta: {
            sidebarFold: true,
            type: '01'
        }
      },
      {
        path: '/my-signature',
        name: '我的签章',
        component: () => import('../views/personal-center/my-signature.vue'),
        meta: {
            sidebarFold: true,
            type: '01'
        }
      },
      {
        path: '/my-address',
        name: '我的地址',
        component: () => import('../views/personal-center/my-address.vue'),
        meta: {
            sidebarFold: true,
            type: '01'
        }
      },
      {
        path: '/supplier-management-add',
        name: '供应商新增',
        component: () => import('../views/basic-supplier/supplier-management-add.vue'),
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            type: '01'
        }
      },
      {        
          path: 'new-sign',
          name: '新签一家企业',
          component: () => import('../views/user-center/new-sign/index.vue'), 
          meta: {
              sidebarFold: true,
              type: '01'
          } 
      },
      {        
          path: 'agreemant-renewal',
          name: '新签业务类型',
          component: () => import('../views/user-center/agreemant-renewal/index.vue'), 
          meta: {
              sidebarFold: true,
              type: '01'
          }
      },  
      {
        path: '/supplier-management-list',
        name: '供应商管理',
        component: () => import('../views/basic-supplier/supplier-management-list.vue'),
        meta: {
            sidebarFold: true,
            type: '01'
        }
      },
      {
        path: '/member-list',
        name: '企业成员列表',
        component: () => import('../views/personal-center/memberList.vue'),
        meta: {
            type: '01'
        }
      },
      {
        path: '/managementList',
        name: '印章管理',
        component: () => import('../views/personal-center/managementList.vue'),
        meta: {
            type: '01'
        }
      },
      {
        path: '/company',
        name: '新增印章',
        component: () => import('../views/personal-center/company.vue'),
        meta: {
            type: '01'
        }
      },
      {
        path: '/classification-confirm-list',
        name: '归类核价确认',
        component: () => import('../views/orders/classification-confirm-list.vue'),
        meta: {
            type: '01'
        }
      },
      {
        path: '/import-statistics',
        name: '进口统计',
        component: () => import('../views/report/import-statistics.vue'),
        meta: {
            type: '01'
        }
      },
      {
        path: '/ic-issue',
        name: '淘IC发布',
        component: () => import('../views/tao-ic/ic-issue.vue'),
        meta: {
            type: '07'
        }
      },
      {
        path: '/issue-record',
        name: '发布记录',
        component: () => import('../views/tao-ic/issue-record.vue'),
        meta: {
            type: '07'
        }
      },
      {
        path: '/issue-operate',
        name: '操作记录',
        component: () => import('../views/tao-ic/issue-operate.vue'),
        meta: {
            type: '07'
        }
      },
      {
        path: '/inventory',
        name: '云库存',
        component: () => import('../views/cloud/inventory.vue'),
        meta: {
            type: '07'
        }
      },
      {
        path: '/query-record-list',
        name: '查询记录',
        component: () => import('../views/cloud/query-record-list.vue'),
        meta: {
            type: '07'
        }
      },
      {
        path: '/client-list',
        name: '客户列表',
        component: () => import('../views/personal-center/client-list.vue'),
        meta: {
            type: '06',
            sidebarFold: true,
        }
      },
      {
        path: '/client-detail',
        name: '新增客户',
        component: () => import('../views/personal-center/client-detail.vue'),
        meta: {
            type: '06',
            keepAlive: true,
        }
      },

      {
        path: '/exchange-settlement-list',
        name: '结汇申请',
        component: () => import('../views/settlement/exchange-settlement-list.vue'),
        meta: {
            type: '02',
           
        }
      },
      
      {
        path: '/exchange-settlement-record-list',
        name: '结汇记录',
        component: () => import('../views/settlement/exchange-settlement-record-list.vue'),
        meta: {
            type: '02',
          
        }
      },
      {
        path: '/service-bill-list',
        name: '服务账单',
        component: () => import('../views/my-account/service-bill-list.vue'),
        meta: {
            type: '01'
        }
      },
      {
        path: '/service-bill-detail',
        name: '服务账单详情',
        component: () => import('../views/my-account/service-bill-detail.vue'),
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            type: '01'
        }
      },
      {
        path: '/exchange-settlement-detail',
        name: '结汇申请详情',
        component: () => import('../views/settlement/exchange-settlement-detail.vue'),
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            type: '02'
        }
      },
      {
        path: '/export-orders-list',
        name: '订单列表',
        component: () => import('../views/orders/export-orders-list.vue'),
        meta: {
            type: '02',
          
        }
      },
      {
        path: '/export-orders-detail',
        name: '出口订单详情',
        component: () => import('../views/orders/export-orders-detail.vue'),
        meta: {
            keepAlive: true,
            type: '02',
        }
      },
      {
        path: '/export-certificate-list',
        name: '代理出口证明',
        component: () => import('../views/personal-center/export-certificate-list.vue'),
        meta: {
            sidebarFold: true,
            type: '02'
        }
      },
    {
        path: 'export-statement-list',
        name: '出口对账单',
        component: () => import('../views/my-account/export-statement-list.vue'),
        meta: {
            type: '02'
        }
    },
    {        
        path: 'export-statement-detail',
        name: '出口对账单详情',
        component: () => import('../views/my-account/export-statement-detail.vue'),  
        meta: {
            keepAlive: true, //设置页面是否需要使用缓存
            type: '02'
        }
    },
]